import {
  GET_FOOD_ITEMS_ADMIN_REQUEST,
  GET_FOOD_ITEMS_ADMIN_SUCCESS,
  GET_FOOD_ITEMS_ADMIN_FAILURE,
  ADD_FOOD_ITEM_ADMIN_REQUEST,
  ADD_FOOD_ITEM_ADMIN_SUCCESS,
  ADD_FOOD_ITEM_ADMIN_FAILURE,
  UPDATE_FOOD_ITEM_ADMIN_REQUEST,
  UPDATE_FOOD_ITEM_ADMIN_SUCCESS,
  UPDATE_FOOD_ITEM_ADMIN_FAILURE,
  DELETE_FOOD_ITEM_ADMIN_REQUEST,
  DELETE_FOOD_ITEM_ADMIN_SUCCESS,
  DELETE_FOOD_ITEM_ADMIN_FAILURE,
  GET_VENDORS_ADMIN_REQUEST,
  GET_VENDORS_ADMIN_SUCCESS,
  GET_VENDORS_ADMIN_FAILURE,
} from "../actions/actionType";

const initialState = {
  loading: false,
  foodItems: [],
  total: 0,
  error: null,
  vendors: [],
  vendorsLoading: false,
  mutating: false,
};

const foodItemsAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FOOD_ITEMS_ADMIN_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_FOOD_ITEMS_ADMIN_SUCCESS:
      return {
        ...state,
        loading: false,
        foodItems: action.payload?.foodItemList || action.payload?.list || action.payload?.foodItems || (Array.isArray(action.payload) ? action.payload : []),
        total: action.payload?.total || (Array.isArray(action.payload) ? action.payload.length : 0),
      };
    case GET_FOOD_ITEMS_ADMIN_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case ADD_FOOD_ITEM_ADMIN_REQUEST:
    case UPDATE_FOOD_ITEM_ADMIN_REQUEST:
    case DELETE_FOOD_ITEM_ADMIN_REQUEST:
      return { ...state, mutating: true };
    case ADD_FOOD_ITEM_ADMIN_SUCCESS:
    case UPDATE_FOOD_ITEM_ADMIN_SUCCESS:
    case DELETE_FOOD_ITEM_ADMIN_SUCCESS:
      return { ...state, mutating: false };
    case ADD_FOOD_ITEM_ADMIN_FAILURE:
    case UPDATE_FOOD_ITEM_ADMIN_FAILURE:
    case DELETE_FOOD_ITEM_ADMIN_FAILURE:
      return { ...state, mutating: false, error: action.payload };

    case GET_VENDORS_ADMIN_REQUEST:
      return { ...state, vendorsLoading: true };
    case GET_VENDORS_ADMIN_SUCCESS:
      return {
        ...state,
        vendorsLoading: false,
        vendors: action.payload?.vendorList || action.payload?.list || action.payload || [],
      };
    case GET_VENDORS_ADMIN_FAILURE:
      return { ...state, vendorsLoading: false };

    default:
      return state;
  }
};

export default foodItemsAdminReducer;
